export const ARRAY_META_KEY = ".zarray";
export const GROUP_META_KEY = ".zgroup";
export const ATTRS_META_KEY = ".zattrs";
